module.exports = __webpack_public_path__ + "img/icon-1-d808d0c0.svg";